const STORE_KEY = 'ADS'

export const FETCH_ADS = `${STORE_KEY}/FETCH_ADS`
